// The Whop landing's copy, shared by the classic and the new look pages.

export const heroContent = {
  member: {
    headline: "Never Miss a Trade Again in Your Whop Group",
    subheadline:
      "Automatically execute your group's signals, including entry, stop-loss, and take-profits, without changing how signals are posted.",
    support:
      "Cornix integration is completely free inside Whop trading groups.",
    primaryCTA: "Send This to My Admin",
    secondaryCTA: "Learn How It Works",
  },
  admin: {
    headline: "Bring Automated Execution to Your Whop Trading Group",
    subheadline:
      "Turn your signal group into a fully automated trading experience, without changing how signals are posted.",
    support: "Cornix integration is completely free for Whop communities.",
    primaryCTA: "",
    secondaryCTA: "Book a 15-Minute Call",
  },
};

export const benefitsContent = {
  member: {
    headline: "Same Signals. Zero Manual Execution.",
    benefits: [
      {
        icon: "zap",
        title: "Never Miss a Trade",
        description:
          "Automated execution captures every signal instantly, even when you're away.",
      },
      {
        icon: "clock",
        title: "No More Manual Mistakes",
        description:
          "Eliminate copy-paste errors with automatic trade execution.",
      },
      {
        icon: "target",
        title: "Automatic Entry, Stop-Loss & Take-Profit",
        description:
          "All targets are executed exactly as posted in your group signals.",
      },
      {
        icon: "refresh",
        title: "Signal Edits Sync Instantly",
        description:
          "Updates automatically reflect in your active trades instantly.",
      },
      {
        icon: "clock8",
        title: "Runs 24/7",
        description: "Never miss a signal while sleeping, working, or away.",
      },
      {
        icon: "gift",
        title: "Free Inside Whop Groups",
        description:
          "Cornix integration is completely free for Whop trading communities.",
      },
    ],
  },
  admin: {
    headline: "Improve Execution Without Changing Your Strategy",
    benefits: [
      {
        icon: "smile",
        title: "Higher member satisfaction",
        description:
          "Members appreciate automation and are more likely to renew their subscriptions.",
      },
      {
        icon: "trending",
        title: "More consistent execution across the group",
        description:
          "Everyone gets the same quality execution with automated signal processing.",
      },
      {
        icon: "message",
        title: "Fewer support questions about entries and targets",
        description:
          "Reduce repetitive support messages about signal execution and order placement.",
      },
      {
        icon: "file",
        title: "No need to change signal format",
        description:
          "Continue posting signals exactly as you do now. No format changes required.",
      },
      {
        icon: "refresh",
        title: "Real-time sync for edits and updates",
        description:
          "Signal updates are automatically reflected in member trades instantly.",
      },
      {
        icon: "gift",
        title: "Free integration for Whop communities",
        description:
          "Cornix integration is completely free for Whop trading groups and their members.",
      },
    ],
  },
};

export const finalCtaContent = {
  member: {
    headline: "Execution Matters in Signal Trading.",
    subheadline: "Automation makes it consistent.",
    primaryCTA: "Copy Message to Admin",
    primaryIcon: "copy",
    secondaryCTA: null as string | null,
  },
  admin: {
    headline: "In Signal Trading, Execution Defines Reputation.",
    subheadline: "Automation makes it scalable.",
    primaryCTA: null as string | null,
    primaryIcon: "send",
    secondaryCTA: "Book a 15-Minute Call" as string | null,
  },
};
